import React from "react";
import Header from "parts/Header";
import Footer from "parts/Footer";
import Discuss from "parts/Discuss";
import RevenueForecast from "parts/RevenueForecast";

const SampleRevenueForecastPage = () => (
  <>
    <Header />
    <RevenueForecast />
    <Discuss />

    <Footer />
  </>
);

export default SampleRevenueForecastPage;
